import React, { useState, useEffect } from "react";
import styled from "styled-components";
import {
  Box,
  Grid,
  TextField,
  Button,
  Typography,
  Select,
  FormControl,
  InputLabel,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Checkbox,
  InputAdornment
} from "@mui/material";

// Icons
import SearchIcon from "@mui/icons-material/Search";
import SaveIcon from "@mui/icons-material/Save";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";



const ServiceCenter = ({ onBack }) => {
  // --- STATE ---
  const [activeTab, setActiveTab] = useState("driverMaster");

  const [form, setForm] = useState({
    serviceName: "",
    contactPerson: "",
    phoneNumber: "",
    roleDetails: "",
    addressDetails: "",
    currentSite: "",
  });

  

  // Dummy Data for visual purposes
  const dummyDrivers = [
    { id: 1, name: "QuickFix Garage", contact: "Ramesh Kumar", site: "1" },
    { id: 2, name: "Heavy Machinery", contact: "Sita Devi", site: "3" },
    { id: 3, name: "Ajax Specialist", contact: "97649422109", site: "2" },
  ];

  // --- HANDLERS ---
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  const handleSave = async () => {
   
    if (!form.serviceName || !form.phoneNumber) {
      alert("Please fill in required fields");
      return;
    }

    // --- LOGIC UPDATED: No external service file used ---
    try {
      // TODO: Add your Firebase logic here directly when ready
      console.log("Saving Service Center Data:", form); 
      
      alert("Service Center Saved Successfully!");
      
      // Reset form
      setForm({
        serviceName: "",
        contactPerson: "",
        phoneNumber: "",
        roleDetails: "",
        addressDetails: "",
        currentSite: "",
      });

      // Go back to list
      if(onBack) onBack(); 

    } catch (error) {
      console.error("Error:", error);
      alert("Error saving data");
    }
  };

  return (
    <Box>
        {/* HEADER SECTION */}
        <Box mb={3}>
            <Typography variant="h4" fontWeight="bold" gutterBottom>
              Service Center Database
            </Typography>
            <Typography variant="body2" color="textSecondary">
              Manage service providers and driver details
            </Typography>
        </Box>

        {/* TOP TABS */}
        <Box mb={3} display="flex" gap={1}>
            <TabButton 
                active={activeTab === "driverMaster"} 
                onClick={() => setActiveTab("driverMaster")}
            >
                Driver Master Data
            </TabButton>
            <TabButton 
                active={activeTab === "serviceDB"} 
                onClick={() => setActiveTab("serviceDB")}
            >
                Service Center Database
            </TabButton>
        </Box>

        {/* MAIN CONTENT GRID */}
        <Grid container spacing={3}>
            
            {/* === LEFT COLUMN: FORM === */}
            <Grid item xs={12} md={5}>
                <SitePage>
                    <SectionHeader>Add New Servicer Name</SectionHeader>

                    <Box display="flex" flexDirection="column" gap={2}>
                        <TextField
                            fullWidth
                            size="small"
                            label="Services Name"
                            name="serviceName"
                            value={form.serviceName}
                            onChange={handleChange}
                            placeholder="Ramesh Kumar"
                            InputLabelProps={{ shrink: true }}
                        />

                        <TextField
                            fullWidth
                            size="small"
                            label="Contact Person"
                            name="contactPerson"
                            value={form.contactPerson}
                            onChange={handleChange}
                            placeholder="Select..."
                            InputLabelProps={{ shrink: true }}
                        />

                        <TextField
                            fullWidth
                            size="small"
                            label="Phone Number"
                            name="phoneNumber"
                            value={form.phoneNumber}
                            onChange={handleChange}
                            placeholder="9876543210"
                            InputLabelProps={{ shrink: true }}
                        />

                        <TextField
                            fullWidth
                            size="small"
                            label="Role / Full Details"
                            name="roleDetails"
                            value={form.roleDetails}
                            onChange={handleChange}
                            InputLabelProps={{ shrink: true }}
                        />

                        <TextField
                            fullWidth
                            size="small"
                            label="Address / Details"
                            name="addressDetails"
                            value={form.addressDetails}
                            onChange={handleChange}
                            multiline
                            rows={2}
                            InputLabelProps={{ shrink: true }}
                        />

                        <FormControl fullWidth size="small">
                            <InputLabel shrink>Current Site Assigned</InputLabel>
                            <Select
                                native
                                name="currentSite"
                                value={form.currentSite}
                                onChange={handleChange}
                                label="Current Site Assigned"
                            >
                                <option value="">Select Site...</option>
                                <option value="Site A">Site A - Kalamboli Yard</option>
                                <option value="Site B">Site B - Panvel</option>
                            </Select>
                        </FormControl>

                        {/* --- BUTTONS ROW --- */}
                        <Box display="flex" gap={2} mt={2}>
                            <Button 
                                variant="outlined" 
                                color="inherit" 
                                fullWidth
                                onClick={onBack}
                                startIcon={<ArrowBackIcon />}
                            >
                                Cancel
                            </Button>
                            <Button 
                                variant="contained" 
                                color="primary" 
                                fullWidth
                                startIcon={<SaveIcon />}
                                onClick={handleSave}
                                sx={{
                                    backgroundColor: "#D32F2F",
                                    "&:hover": { backgroundColor: "#9A0007" }
                                }}
                            >
                                Save Driver
                            </Button>
                        </Box>
                    </Box>
                </SitePage>
            </Grid>

            {/* === RIGHT COLUMN: LIST & DETAILS === */}
            <Grid item xs={12} md={7}>
                <SitePage>
                    
                    {/* Search Bar */}
                    <Box display="flex" justifyContent="space-between" alignItems="center" mb={2} p={1} bgcolor="#f5f5f5" borderRadius={1}>
                        <Typography variant="subtitle2" fontWeight="bold" sx={{ ml: 1 }}>
                            Driver List
                        </Typography>
                        <TextField 
                            size="small" 
                            placeholder="Search..."
                            variant="standard"
                            InputProps={{
                                disableUnderline: true,
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <SearchIcon color="action" />
                                    </InputAdornment>
                                )
                            }}
                            sx={{ bgcolor: "white", px: 1, borderRadius: 1 }}
                        />
                    </Box>

                    {/* TABLE 1: Driver List */}
                    <TableContainer sx={{ mb: 4, border: "1px solid #eee" }}>
                        <Table size="small">
                            <TableHead sx={{ bgcolor: "#333" }}>
                                <TableRow>
                                    <StyledHeaderCell>Name</StyledHeaderCell>
                                    <StyledHeaderCell>Contact Person</StyledHeaderCell>
                                    <StyledHeaderCell align="right">Current Site</StyledHeaderCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {dummyDrivers.map((row) => (
                                    <TableRow key={row.id}>
                                        <TableCell>{row.name}</TableCell>
                                        <TableCell>{row.contact}</TableCell>
                                        <TableCell align="right">{row.site}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>

                    {/* EXPANSION / DETAIL VIEW */}
                    <SectionHeader>Expansion / Detail View</SectionHeader>
                    
                    <Box bgcolor="#f9f9f9" p={2} borderRadius={2} border="1px solid #eee">
                        <Grid container spacing={2} alignItems="flex-end" mb={2}>
                            <Grid item xs={4}>
                                <TextField 
                                    fullWidth 
                                    size="small" 
                                    label="Service Date" 
                                    defaultValue="General" 
                                    InputLabelProps={{ shrink: true }} 
                                />
                            </Grid>
                            <Grid item xs={4}>
                                <TextField 
                                    fullWidth 
                                    size="small" 
                                    label="Vehicle Plate" 
                                    defaultValue="8766 MH 4B" 
                                    InputProps={{
                                        startAdornment: <Checkbox size="small" defaultChecked />
                                    }}
                                />
                            </Grid>
                            <Grid item xs={4}>
                                <TextField 
                                    fullWidth 
                                    size="small" 
                                    label="Claim Utilized?" 
                                    defaultValue="Yes" 
                                    InputLabelProps={{ shrink: true }} 
                                />
                            </Grid>
                        </Grid>

                        {/* TABLE 2: Fine History */}
                        <TableContainer sx={{ border: "1px solid #e0e0e0" }}>
                            <Table size="small">
                                <TableHead sx={{ bgcolor: "#444" }}>
                                    <TableRow>
                                        <StyledHeaderCell>Penalty/Fine History</StyledHeaderCell>
                                        <StyledHeaderCell>Type</StyledHeaderCell>
                                        <StyledHeaderCell>Status</StyledHeaderCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <TableRow>
                                        <TableCell>Rs 2-05-20</TableCell>
                                        <TableCell>Speeding</TableCell>
                                        <TableCell>EV Specialist</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>

                </SitePage>
            </Grid>

        </Grid>
    </Box>
  );
};

// --- STYLED COMPONENTS ---

const SitePage = styled.div`
  padding: 25px;
  background-color: #fff;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  height: 100%;
`;

const SectionHeader = styled.h6`
  font-weight: 700;
  font-size: 1rem;
  color: #333;
  margin-bottom: 15px;
  border-bottom: 2px solid #f0f0f0;
  padding-bottom: 8px;
`;

// Custom Button for Tabs
const TabButton = styled.button`
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  font-weight: 600;
  cursor: pointer;
  background-color: ${props => props.active ? "#D32F2F" : "#fff"};
  color: ${props => props.active ? "#fff" : "#333"};
  box-shadow: 0 1px 2px rgba(0,0,0,0.1);
  transition: all 0.2s;

  &:hover {
background-color: ${props => props.active ? "#9A0007" : "#f5f5f5"};
  }
`;

// Helper for Table Headers to match the dark header look in mockup
const StyledHeaderCell = styled(TableCell)`
  && {
    color: white;
    font-weight: bold;
    padding: 8px 16px;
  }
`;

export default ServiceCenter;